import React, { Component } from 'react'
import classes from "./Footer.module.css"

class Footer extends Component {
    render() {
        return (
            <div className={classes.footer_top}>
                <p>Designed By Ikenna</p>
                
            </div>
        )
    }
}

export default Footer